import { useSelector } from "react-redux";

export const useChaseIqAccess = () => {
  const { chaseIqEnabled, isAdmin, permissions } = useSelector(
    (state) => state.commonReducer.commonProps
  );
  return chaseIqEnabled && (isAdmin || permissions?.includes("dashboard_chase_iq"));
};
